import { SVGProps } from "react";

export const Calculator = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fill="#fff"
      d="M15.625 1.563H4.375a1.562 1.562 0 0 0-1.563 1.562v13.75a1.563 1.563 0 0 0 1.563 1.563h11.25a1.563 1.563 0 0 0 1.563-1.563V3.125a1.563 1.563 0 0 0-1.563-1.563Zm-.313 15H4.688V3.438h10.625v13.124ZM6.25 5.938A.937.937 0 0 1 7.188 5h5.625a.937.937 0 0 1 0 1.875H7.186a.937.937 0 0 1-.937-.938ZM9.375 10a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm3.75 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-3.75 3.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm3.75 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
    />
  </svg>
);

export const Retirement = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" fill="none" viewBox="0 0 10 14" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M7.667 9.018a1 1 0 112 0v4.315a.333.333 0 11-.667 0V9.018a.333.333 0 00-.667 0v.114a.333.333 0 01-.667 0v-.114z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.085 4.667c-.659 0-1.185.22-1.546.572a1.779 1.779 0 00-.408 1.943c.09.217.222.414.39.578.348.341.853.556 1.487.572l.325.009v4.415c0 .089.095.235.317.244.222.008.339-.133.349-.227l.326-3.106h1.35L6 12.773c.01.094.127.235.35.227.22-.009.316-.155.316-.244v-7.34l.47.214c.369.167.608.38.766.572.173.211.338.5.38.817l.001.007v.005c.018.17.18.318.39.301.2-.016.342-.189.327-.36a1.73 1.73 0 00-.088-.382 2.48 2.48 0 00-.44-.792c-.485-.59-1.375-1.131-2.948-1.131h-2.44zm-2.011.095c.5-.488 1.2-.762 2.01-.762h2.44c1.742 0 2.833.607 3.465 1.374.246.298.435.64.557 1.006.054.161.102.341.119.532v.002c.05.575-.406 1.04-.938 1.083-.546.043-1.046-.342-1.105-.892a1.033 1.033 0 00-.234-.48 1.218 1.218 0 00-.055-.061v6.192c0 .528-.465.89-.957.91-.49.019-.984-.302-1.038-.824l-.264-2.509h-.149l-.263 2.51c-.055.52-.549.842-1.039.823-.491-.02-.957-.382-.957-.91v-3.78c-.641-.077-1.196-.332-1.612-.74a2.405 2.405 0 01-.72-1.745 2.445 2.445 0 01.74-1.73zm2.26.557V7.68l-.349-.015c-.442-.02-.745-.17-.942-.363a1.098 1.098 0 01-.324-.799 1.137 1.137 0 01.34-.805c.2-.193.5-.342.925-.362l.35-.017zm-.667.76a.471.471 0 00-.281.43.43.43 0 00.28.419v-.849zM5 1a1 1 0 100 2 1 1 0 000-2zM3.333 2a1.667 1.667 0 113.333 0 1.667 1.667 0 01-3.333 0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.804 6.08a1.167 1.167 0 01.218-.343l.001-.001a1.143 1.143 0 01.375-.267c.16-.073.355-.122.586-.133l.35-.017V7.68l-.349-.015a1.656 1.656 0 01-.652-.157 1.145 1.145 0 01-.288-.204l-.002-.002-.001-.002a1.106 1.106 0 01-.323-.791v-.006a1.14 1.14 0 01.085-.424zM1 6.49c.003-.232.052-.462.143-.675a1.779 1.779 0 01.431-.61l.003-.002c.335-.308.8-.507 1.375-.533a2.89 2.89 0 01.133-.003h2.44l.141.001c.239.005.46.023.667.052a4.509 4.509 0 01.816.19c.094.033.183.068.268.105.453.2.785.465 1.024.743v.001l.033.039a2.48 2.48 0 01.439.791v.002c.037.104.064.212.08.321v.002a2.406 2.406 0 01.004.023v.005a8.333 8.333 0 01.004.03c.015.171-.127.344-.327.36a.364.364 0 01-.34-.163.32.32 0 01-.049-.135v-.008l-.002-.007v-.008a1.327 1.327 0 00-.044-.196 1.58 1.58 0 00-.1-.251 1.925 1.925 0 00-.204-.321v-.001a1.994 1.994 0 00-.268-.28 2.222 2.222 0 00-.53-.332l-.47-.214v7.34c0 .089-.096.235-.317.244-.222.008-.34-.133-.35-.227l-.325-3.106h-1.35l-.326 3.106c-.01.094-.128.235-.35.227-.22-.01-.316-.155-.316-.244V8.34l-.325-.009-.052-.001h-.001a2.793 2.793 0 01-.21-.017c-.49-.059-.891-.245-1.186-.518l-.003-.002A1.738 1.738 0 011 6.499v-.002-.007zM3.085 4c-.811 0-1.51.274-2.01.76l-.002.002a2.445 2.445 0 00-.74 1.727v.001a2.406 2.406 0 00.721 1.746c.343.336.778.568 1.28.682.107.025.219.044.333.058v3.78c0 .528.465.89.956.91.301.012.604-.105.805-.318a.859.859 0 00.234-.505l.263-2.51h.15l.263 2.51a.86.86 0 00.234.504c.2.214.503.33.804.319.491-.02.957-.382.957-.91V6.564c.019.02.037.04.054.061v.001a1.055 1.055 0 01.235.479v.003a1.014 1.014 0 00.71.845c.125.039.259.055.395.044.532-.044.988-.507.938-1.082v-.003l-.002-.014a2.412 2.412 0 00-.117-.518v-.002a3.147 3.147 0 00-.557-1.004c-.484-.587-1.235-1.08-2.34-1.279a5.642 5.642 0 00-.313-.047h-.003A6.208 6.208 0 005.525 4h-2.44zm.581-1a1.667 1.667 0 102.668-2 1.667 1.667 0 00-2.668 2zm-1 3.928v-.849a.471.471 0 00-.14.095l-.001.002a.471.471 0 00-.14.331v.003a.47.47 0 00.032.175.405.405 0 00.094.141l.002.003a.5.5 0 00.154.099zm1.627-5.635a1 1 0 111.414 1.414 1 1 0 01-1.414-1.414z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const CashBag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    fill="none"
    viewBox="0 0 13 14"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.268.459h3.94A1.154 1.154 0 019.15 2.26l-.7.902c1.167.657 2.094 1.427 2.752 2.359.769 1.089 1.143 2.362 1.143 3.85 0 1.478-.685 2.576-1.823 3.278-1.106.682-2.612.976-4.287.976-1.674 0-3.18-.294-4.285-.973C.812 11.953.125 10.86.125 9.39c0-1.489.375-2.761 1.144-3.851.658-.934 1.586-1.707 2.755-2.367l-.705-.913a1.154 1.154 0 01.944-1.8h.005zM4.27 1.54a.071.071 0 00-.065.094l1.066 1.382a.541.541 0 01-.185.815c-1.342.675-2.305 1.438-2.934 2.33-.623.885-.945 1.933-.945 3.228 0 1.073.473 1.826 1.308 2.34.867.531 2.146.812 3.72.812 1.573 0 2.851-.28 3.718-.815.834-.514 1.309-1.272 1.309-2.356 0-1.295-.322-2.343-.945-3.226-.629-.89-1.591-1.651-2.933-2.322a.541.541 0 01-.185-.816l1.066-1.373a.07.07 0 00-.066-.093H4.27zm1.964 3.131c.3 0 .542.243.542.542v.872a.541.541 0 01-1.083 0v-.872c0-.3.242-.542.541-.542zm0 4.65c.3 0 .542.242.542.541v.938a.541.541 0 01-1.083 0v-.938c0-.299.242-.541.541-.541z"
      clipRule="evenodd"
    ></path>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.194 6.672a.489.489 0 00-.516.386.498.498 0 00.52.39 1.58 1.58 0 011.68 1.412.541.541 0 010 .113 1.581 1.581 0 01-1.65 1.414 1.692 1.692 0 01-1.334-.602.541.541 0 11.828-.697.61.61 0 00.491.216h.06a.498.498 0 00.52-.387.498.498 0 00-.52-.388 1.58 1.58 0 01-1.68-1.412.541.541 0 010-.109A1.572 1.572 0 016.24 5.59a1.71 1.71 0 011.32.545.541.541 0 11-.793.737.628.628 0 00-.498-.2.541.541 0 01-.075 0z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const Auto = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    fill="none"
    viewBox="0 0 12 10"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.265.333a1.647 1.647 0 011.372.736l.058.094 1.094 1.915h.638a.22.22 0 01.216.176l.004.044v.26a.44.44 0 01-.276.409l-.07.022c.206.427.297.9.266 1.373l-.015.158-.398 3.185a1.098 1.098 0 01-1.003.958l-.087.004h-.613A1.098 1.098 0 018.356 8.65l-.003-.082H3.96a1.098 1.098 0 01-1.016 1.095l-.082.003h-.614a1.098 1.098 0 01-1.076-.877l-.013-.085L.76 5.52c-.058-.47.006-.949.187-1.387l.064-.145L1 3.985A.44.44 0 01.67 3.62l-.003-.06v-.261a.22.22 0 01.175-.215l.044-.005h.639l1.094-1.915a1.647 1.647 0 011.32-.826l.11-.004h4.216zm2.152 4.412c-.284.311-.678.5-1.098.526l-.113.004H3.107a1.625 1.625 0 01-1.21-.53 1.647 1.647 0 00-.057.51l.011.129.398 3.185h.614v-.55a.549.549 0 01.484-.545l.065-.003h5.49a.55.55 0 01.545.484l.004.065v.549h.613l.398-3.185a1.634 1.634 0 00-.045-.639zM2.718 5.768l1.506.813c.205.111.12.422-.113.413l-1.27-.051a.549.549 0 01-.527-.548V6.01a.275.275 0 01.405-.241v-.001zM10 6.009v.385a.55.55 0 01-.527.549l-1.27.05c-.233.01-.319-.301-.113-.412l1.505-.813A.275.275 0 0110 6.01zM8.265 1.431H4.048a.549.549 0 00-.476.277L2.63 3.355a.549.549 0 00.476.821h6.099a.55.55 0 00.476-.82l-.94-1.648a.549.549 0 00-.478-.277z"
    ></path>
  </svg>
);

export const House = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    fill="none"
    viewBox="0 0 15 13"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.481 7.399A.68.68 0 011.03 6.21L7.15.771a.68.68 0 01.902 0l6.12 5.44a.68.68 0 01-.452 1.188h-.68v4.76a.68.68 0 01-.68.68H2.841a.68.68 0 01-.68-.68v-4.76h-.68zm4.08 4.08v-3.4a.68.68 0 01.68-.68h2.72a.68.68 0 01.68.68v3.4h2.04v-4.76a.681.681 0 01.347-.594L7.601 2.19 3.173 6.125a.68.68 0 01.348.594v4.76h2.04zm1.36 0v-2.72h1.36v2.72H6.92z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const CreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    fill="none"
    viewBox="0 0 14 12"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.333 2a.667.667 0 00-.666.667v.666h10.666v-.666A.666.666 0 0011.668 2H2.333zm10 2.667H1.668v4.666a.667.667 0 00.666.667h9.334a.667.667 0 00.667-.667V4.667zM.92 1.252A2 2 0 012.333.667h9.334a2 2 0 012 2v6.666a2 2 0 01-2 2H2.333a2 2 0 01-2-2V2.667A2 2 0 01.92 1.252zM3 6.667C3 6.298 3.3 6 3.667 6H7a.667.667 0 010 1.333H3.667A.667.667 0 013 6.667z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const Hamburger = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={12} fill="none" {...props}>
    <path
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M1 11h18M1 6h18M1 1h18"
    />
  </svg>
);

export const Close = (props: SVGProps<SVGSVGElement>) => (
  <svg width={14} height={14} fill="none" {...props}>
    <path
      stroke="#FAFAFA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13 13 7 7m0 0L1 1m6 6 6-6M7 7l-6 6"
    />
  </svg>
);
